import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {JORNADA_SERVICOS_ONLINE, SOLICITACAO_AUTORIZACAO} from './autorizacao-api';
import {Beneficiario} from "../shared/models/beneficiario.model";
import {BehaviorSubject, Observable} from "rxjs";
import {User} from "../shared/models/user.model";


@Injectable({providedIn: 'root'})
export class RedefinirSenhaService {
  private forgotPasswordUserSubject: BehaviorSubject<any>;
  public forgotPasswordUser: Observable<Beneficiario>;
  url: string = SOLICITACAO_AUTORIZACAO;
  urlJornada: string = JORNADA_SERVICOS_ONLINE;

  constructor(private http: HttpClient) {
    this.forgotPasswordUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('forgotPasswordUser')));
    this.forgotPasswordUser = this.forgotPasswordUserSubject.asObservable();
  }

  public get forgotPasswordUserValue(): Beneficiario {
    return this.forgotPasswordUserSubject.value;
  }

  salvarBeneficiarioLocalStorage(beneficiario: Beneficiario) {
    if (beneficiario) {
      localStorage.setItem('forgotPasswordUser', JSON.stringify(beneficiario));
      this.forgotPasswordUserSubject.next(beneficiario);
    }
  }

  removerBeneficiarioLocalStorage() {
    localStorage.removeItem('forgotPasswordUser');
    this.forgotPasswordUserSubject.next(null);
  }

  recuperarUsuario(id: string, dtNascimento: string, tipoId: string) {
    let params = new HttpParams();
    params = params.append('id', id).append('dtNascimento', dtNascimento).append('tipoId', tipoId);
    return this.http.get(this.urlJornada + '/beneficiario/login/esqueci/usuario', {params: params})
      .pipe(map(res => res));
  }

  esqueciSenha(cdPessoa: string, telefone: string) {
    let params = new HttpParams();
    params = params.append('cdPessoa', cdPessoa);
    if (telefone != null) {
      params = params.append('celular', telefone);
    }

    const options: Object = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'text',
      observe: 'response',
      params: params
    };
    return this.http.post<any>(this.urlJornada + '/beneficiario/login/esqueci', null, options);
  }

  reenviarToken(cdPessoa: string) {
    let params = new HttpParams();
    params = params.append('cdPessoa', cdPessoa);

    const options: Object = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'text',
      observe: 'response',
      params: params
    };
    return this.http.post(this.urlJornada + '/beneficiario/login/esqueci/reenvia', null, options)
      .pipe(map(res => res));
  }

  redefinirSenha(beneficiario: Beneficiario) {
    let body = {
      "cdPessoa": beneficiario.cdPessoa,
      "cdSenha": beneficiario.cdSenha,
      "contraSenha": beneficiario.cdSenha,
      "token": beneficiario.token
    };
    return this.http.post(this.urlJornada + '/beneficiario/login/esqueci/confirmar', body)
      .pipe(map(res => res));
  }
}
